import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Projectperson } from '@src/app/components/org/orgprojectlist/model/projectperson';
import { Project } from '@src/app/models/project';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FooterprojectlistService {

  constructor(private http:HttpClient) { }
  // /organization/{organizationId}/organizationproject/list
  getProjects(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Project[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/organizationproject/list',httpOptions);

  }
  //GET	    /customer/{customerId}/project/list/pit/{pitdate}
  getCustomerProjects(pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Project[]>(environment.apiUrl+'/customer/'+JSON.parse(SessionHelper.getCustomer()).customerId.split('_')[0]+'/project/list/pit/'+pit,httpOptions);

  }
    // /project/{projectId}/task/list/pit/{pitdate}
    // getTasks(projectId:string,pit:string){
    //   const httpOptions = {
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json',
    //       'Authorization': SessionHelper.getIdToken()
    //     })
    //   }
    //   return this.http.get<Task[]>(environment.apiUrl+'/project/'+projectId+'/task/list/pit/'+pit,httpOptions);
    // }


    //get one project per projectId
    // GET	/project/{projectId}
    getProject(projectId:string){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': SessionHelper.getIdToken()
        })
      }
      return this.http.get<Project>(environment.apiUrl+'/project/'+projectId,httpOptions);
    }
}
